import React, { useState } from 'react';

export default function OptionGroup({ title, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className={`tpb-option-group${open ? ' is-open' : ''}`}>
      <button
        type="button"
        className="tpb-option-group-toggle"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <i className={`fas fa-chevron-${open ? 'down' : 'right'}`} aria-hidden="true" />
        {title}
      </button>
      {open && <div className="tpb-option-group-body">{children}</div>}
    </section>
  );
}
